<template>
  <div class="video-container">
    <video
      ref="videoRef"
      class="video-container"
      :src="src"
      :poster="poster"
      @ended="playing = false"
      @click.stop="handleClickVideo"
    ></video>
    <img
      v-if="!playing"
      class="play-icon"
      src="https://logo.wondercv.com/banners/RdxU4QviU5geiL3.png"
      alt=""
      @click.stop="handleClickVideo"
    />
    <img
      v-if="displayMask"
      class="video-mask"
      src="https://staging-file-uploaded.oss-cn-beijing.aliyuncs.com/spring_recruits/34ffe0a0-8b00-11ef-a098-1508e11b691d.png"
      alt=""
      @click.stop="handleClickVideo"
    />
  </div>
</template>
<script>
export default {
  props: {
    src: String,
    poster: String,
    activeIndex: Number,
    displayMask: Boolean,
  },
  data() {
    return {
      playing: false,
    };
  },
  watch: {
    activeIndex() {
      this.$refs.videoRef.pause();
      this.playing = false;
    },
  },
  methods: {
    handleClickVideo() {
      if (this.playing) {
        this.$refs.videoRef.pause();
        this.playing = false;
      } else {
        this.$refs.videoRef.play();
        this.playing = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.video-container {
  position: relative;
  width: 100%;
  height: 100%;
  video {
    object-fit: cover;
  }
  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 44px;
    height: 44px;
    z-index: 10;
    border-radius: 50%;
    cursor: pointer;
  }
  .video-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    width: 100%;
  }
}
</style>
